import styled from "styled-components";
import themes from "@/styles/themes";

/**
 * Topo do checkout na variante de teste do experimento "offer_details_highlight".
 *
 * Diferente do DetailsCard (controle), aqui não existe card branco, nem
 * centralização, nem o botão "Detalhes": é só o bloco de texto alinhado à
 * esquerda. A linha azul que aparece abaixo dele no layout é o border-top do
 * AcordionHeader da Identificação, por isso este bloco não desenha borda.
 */
const OfferHighlightCard = styled.div`
  background: none;
  padding: 4px 0 16px 0;
  text-align: left;

  p.plan-name {
    font-size: 14px;
    font-weight: 700;
    color: ${themes.estadao};
    margin: 0 0 2px 0;
    line-height: 1.3;
  }

  h4.offer-highlight {
    font-size: 26px;
    font-weight: 900;
    color: ${themes.greyDark};
    margin: 0 0 4px 0;
    line-height: 1.2;
  }

  p.offer-bonus {
    font-size: 14px;
    font-weight: 700;
    color: ${themes.greyDark};
    margin: 0 0 2px 0;
    line-height: 1.4;
  }

  p.offer-renew {
    font-size: 14px;
    font-weight: 400;
    color: ${themes.greyNormal};
    margin: 0;
    line-height: 1.4;
  }

  /* no Zeplin o "Cancele quando quiser" fica destacado das linhas de preço */
  p.offer-cancel {
    font-size: 14px;
    font-weight: 400;
    color: ${themes.greyNormal};
    margin: 6px 0 0 0;
    line-height: 1.4;
  }

  @media (min-width: ${themes.sm}px) {
    h4.offer-highlight {
      font-size: 30px;
    }
  }
`

export default OfferHighlightCard
